import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CaretLeft, ShieldCheck } from "@phosphor-icons/react";

const THIRD = [
  ["Emergent Labs (Google Cloud, Amazon Web Services, MongoDB Atlas)", "Hosting aplikasi dan database", "Amerika Serikat"],
  ["Cloudflare", "Jaringan dan keamanan situs", "Global"],
  ["Midtrans", "Pembayaran VA/QRIS", "Indonesia"],
  ["WACloud.id", "Notifikasi WhatsApp", "Dikonfirmasi ke penyedia"],
  ["Resend", "Notifikasi email", "Dikonfirmasi ke penyedia"],
];

const Sec = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="font-heading text-base font-extrabold text-[#6A38C7] md:text-lg">{title}</h2>
    <div className="space-y-2 text-sm leading-relaxed text-slate-700">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  useEffect(() => { document.title = "Kebijakan Privasi — HaloGBS"; window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-[#FAF7FF]" data-testid="privacy-page">
      <header className="border-b border-[#E0D2FF] bg-white">
        <div className="mx-auto flex max-w-3xl items-center gap-3 px-4 py-4">
          <ShieldCheck size={26} weight="duotone" className="text-[#7C4DE0]" />
          <p className="font-heading text-sm font-extrabold text-slate-800">HaloGBS · Griya Bunda Sehat</p>
          <Link to="/booking" data-testid="privacy-back" className="ml-auto inline-flex items-center gap-1 text-sm font-semibold text-[#DB2777]"><CaretLeft size={14} /> Reservasi</Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl space-y-7 px-4 py-8">
        <div>
          <h1 className="font-heading text-3xl font-extrabold text-slate-800 sm:text-4xl">Kebijakan Privasi HaloGBS</h1>
          <p data-testid="privacy-effective" className="mt-2 inline-block rounded-full bg-[#EEE6FF] px-3 py-1 text-xs font-bold text-[#6A38C7]">Berlaku sejak: 3 November 2026</p>
        </div>
        <p className="text-sm leading-relaxed text-slate-700">HaloGBS (reservasi.griyabundasehat.com) dikelola oleh PT Griya Bunda Sehat (Klinik Pratama Rawat Inap Griya Bunda Sehat), Jl. Mulawarman PJHI RT.14 No.16A, Kel. Manggar, Kec. Balikpapan Timur, Kota Balikpapan, Kalimantan Timur 76116. Kami menghormati privasi Anda dan menjaga data pribadi sesuai UU No. 27 Tahun 2022 tentang Pelindungan Data Pribadi serta ketentuan rahasia medis.</p>
        <Sec title="Data yang kami kumpulkan">
          <ul className="list-none space-y-1.5">
            <li><b>(a) Identitas dan kontak:</b> nama, nomor HP/WhatsApp, email, tanggal lahir, alamat.</li>
            <li><b>(b) Data kesehatan:</b> keluhan, catatan konsultasi dan telekonsultasi, resep, riwayat layanan di klinik.</li>
            <li><b>(c) Data transaksi:</b> layanan yang dipesan, jadwal, tagihan, status pembayaran.</li>
            <li><b>(d) Data teknis:</b> alamat IP dan log akses untuk keamanan sistem.</li>
          </ul>
        </Sec>
        <Sec title="Tujuan penggunaan">
          <p>Mengatur reservasi, jadwal petugas, dan antrean; memberikan pelayanan kesehatan termasuk telekonsultasi, resep, dan homecare; memproses pembayaran dan tagihan; mengirim konfirmasi dan pengingat melalui WhatsApp atau email; memenuhi kewajiban hukum termasuk penyimpanan rekam medis. Kami tidak menjual data Anda dan tidak memakainya untuk iklan pihak lain.</p>
        </Sec>
        <Sec title="Dasar pemrosesan">
          <p>Persetujuan Anda saat booking, pelaksanaan layanan yang Anda pesan, kewajiban hukum fasilitas kesehatan, dan pelindungan kepentingan vital dalam keadaan darurat medis.</p>
        </Sec>
        <Sec title="Pihak ketiga dan lokasi data">
          <div className="overflow-x-auto rounded-xl border border-[#E0D2FF] bg-white">
            <table data-testid="privacy-third-party-table" className="w-full min-w-[480px] text-left text-xs sm:text-sm">
              <thead className="bg-[#EEE6FF] text-[#6A38C7]"><tr><th className="px-3 py-2">Penyedia</th><th className="px-3 py-2">Fungsi</th><th className="px-3 py-2">Lokasi</th></tr></thead>
              <tbody>
                {THIRD.map(([a, b, c]) => <tr key={a} className="border-t border-slate-100"><td className="px-3 py-2 font-semibold text-slate-800">{a}</td><td className="px-3 py-2">{b}</td><td className="px-3 py-2">{c}</td></tr>)}
              </tbody>
            </table>
          </div>
          <p>Karena sebagian data disimpan di luar Indonesia, kami memastikan penyedia menerapkan standar keamanan yang setara.</p>
        </Sec>
        <Sec title="Keamanan">
          <p>Akses data dibatasi sesuai peran (admin, petugas, pasien). Koneksi situs dienkripsi (HTTPS). Seluruh petugas terikat kewajiban menjaga rahasia medis.</p>
        </Sec>
        <Sec title="Masa simpan">
          <p>Rekam medis disimpan paling singkat 25 tahun sejak kunjungan terakhir sesuai Permenkes No. 24 Tahun 2022. Data non-medis (misalnya booking yang dibatalkan) disimpan paling lama 2 tahun, lalu dihapus.</p>
        </Sec>
        <Sec title="Hak Anda">
          <p>Anda berhak meminta akses dan salinan data, memperbaiki data yang keliru, menarik persetujuan, serta meminta penghapusan data di luar rekam medis yang wajib disimpan. Kami menanggapi permintaan paling lambat 3x24 jam setelah identitas Anda terverifikasi.</p>
        </Sec>
        <Sec title="Hubungi kami">
          <div data-testid="privacy-contact" className="rounded-xl border border-[#E0D2FF] bg-white p-4">
            <p>Pejabat Pelindungan Data Pribadi: <b>Neny Rahmawati (Direktur)</b></p>
            <p><a className="font-semibold text-[#7C4DE0] underline" href="mailto:griyabundasehat123@gmail.com">griyabundasehat123@gmail.com</a> · WhatsApp <a className="font-semibold text-[#7C4DE0] underline" href="https://wa.me/6281348224907" target="_blank" rel="noreferrer">0813-4822-4907</a></p>
          </div>
          <p>Jika terjadi kebocoran data yang berdampak pada Anda, kami akan memberi tahu Anda secara tertulis paling lambat 3x24 jam sejak kejadian dipastikan.</p>
          <p>Kebijakan ini dapat diperbarui. Perubahan penting akan kami umumkan di halaman ini.</p>
        </Sec>
      </main>
    </div>
  );
}
